__turbopack_context__.v({
  "badgeL": "ArSpaceCard-module-scss-module__CThFIq__badgeL",
  "badgeR": "ArSpaceCard-module-scss-module__CThFIq__badgeR",
  "btnMore": "ArSpaceCard-module-scss-module__CThFIq__btnMore",
  "footer": "ArSpaceCard-module-scss-module__CThFIq__footer",
  "item": "ArSpaceCard-module-scss-module__CThFIq__item",
  "local": "ArSpaceCard-module-scss-module__CThFIq__local",
  "title": "ArSpaceCard-module-scss-module__CThFIq__title",
});
